import { Link } from 'react-router-dom';
import React, { Component } from 'react'; 

class Rompecabezas extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Rompecabezas</h2>
              </header>
              <span className="containerjuego">
          <div className="content">
            <div>
            </div>
        <iframe title='Rompecabezas' src="https://www.jigsawplanet.com/?rc=play&amp;pid=3a44cf166a46&amp;view=iframe&amp;bgcolor=0x808080" width="1080" height="720" frameborder="1" allowfullscreen></iframe>
          </div>
            <div>
            <div className="containerjuego">
              <Link className="button" to="/juego">
                Regresar
              </Link>
            </div>
            </div>
            </span>
          </div>
          </div>
          );
    } 
} 

export default Rompecabezas;